module.exports = __webpack_public_path__ + "static/img/banner-t20.b2c8fdc8.png";